import { useMemo } from 'react';
import { Chain } from '@ankr.com/chains-list';

import { getChainGroups } from '../constants/groups';
import { GroupedEndpoints } from '../types';
import { getGroupedEndpoints } from '../utils/getGroupedEndpoints';

export const useGroupedEndpoints = (
  chain: Chain,
  shouldExpandMainnets = false,
  shouldExpandTestnets = false,
): GroupedEndpoints =>
  useMemo(
    () =>
      getGroupedEndpoints({
        chain,
        groups: getChainGroups(),
        shouldExpandMainnets,
        shouldExpandTestnets,
      }),
    [chain, shouldExpandTestnets, shouldExpandMainnets],
  );
